import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubHeadings, setselectedTab } from "../../../Store/B2bslice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getRemitters,
  getRemittersByAccountXPay,
  getRemittersXPay,
  getVerifyRemitterXPay,
} from "../../../ApiServices/Apifun";
import { Button, Radio, Spin } from "antd";
import { Images } from "../../../Controller";
import BeneficiaryCardxPay from "./BeneficiaryCardxPay";
import VerifyRemitterOtp from "./VerifyRemitterOtp";

const GetRemitterXPay = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [mobile, setMobile] = useState("");
  const [account, setAccount] = useState("");
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [isVerified, setIsVerified] = useState(null);
  const [type, setType] = useState("Bank");
  const [beneModal, setBeneModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const checkKyc = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const [beneficiariesDetails, setbeneficiariesDetails] = useState([]);
  const [remitterName, setRemitterName] = useState("");
  const [showNameField, setShowNamefield] = useState(false);
  const [openOtpVerifyModal, setOpenVerifyOTPModal] = useState(false);
  const [remitterDetails, setremitterDetails] = useState({});
  useEffect(() => {
    dispatch(setSubHeadings(""));
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    const sanitized = value.replace(/[^0-9]/g, "");
    const limitedNumbers = sanitized.slice(0, 10);
    setMobile(limitedNumbers);
    setShowNamefield(false);
    setBeneModal(false);
  };
  const handleSearchByAccount = () => {
    setLoader(true);
    const formdata = new FormData();

    formdata.append("account_no", account);
    getRemittersByAccountXPay(formdata)
      .then((res) => {
        if (res.status) {
          setremitterDetails(res.data);
          // setbeneficiariesDetails(res.data?.beneficiaries);
          setBeneModal(true);
        } else {
          // console.log("comes in else condition");
          // setShowNamefield(true);
          setbeneficiariesDetails([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setbeneficiariesDetails([]);
      })
      .finally(() => setLoader(false));
  };
  const handleSearch = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("type", type);
    formdata.append("search_keyword", searchKeyword);
    formdata.append("mobile_number", mobile);
    getRemittersXPay(formdata)
      .then((res) => {
        if (res.status) {
          setbeneficiariesDetails(res.data?.beneficiaries);
          setBeneModal(true);
          const data = res.data?.remitter;

          setremitterDetails(Array.isArray(data) ? data : [data]);

          setIsVerified(true);
        } else {
          console.log("comes in else condition");
          setIsVerified(false);

          setbeneficiariesDetails([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setbeneficiariesDetails([]);
      })
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    if (searchKeyword?.length > 5) {
      handleSearch();
    }
  }, [searchKeyword]);

  const handleVerifyMobile = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("name", remitterName);
    formdata.append("mobile", mobile);
    getVerifyRemitterXPay(formdata)
      .then((res) => {
        if (res.status) {
          console.log("setOpenVerifyOTPModal");
          setOpenVerifyOTPModal(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoader(false));
  };

  return (
    <>
      <Spin spinning={loader}>
        <p className="font-bold text-xl">Remitter Search</p>

        <div className="mt-4 flex flex-col md:flex-row gap-4">
          {/* Mobile Search */}
          <div className="flex items-center w-full md:w-1/2 gap-2">
            <input
              value={mobile}
              onChange={(e) => {
                setMobile(e.target.value);
                setAccount("");
                setremitterDetails([]);
                setbeneficiariesDetails([]);
              }}
              placeholder="Enter mobile number"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />
            <SearchOutlined
              onClick={() => mobile && handleSearch()}
              className={`w-10 h-10 rounded-full flex items-center justify-center
        ${mobile ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            />
          </div>
          {/* Account Search */}
          <div className="flex items-center w-full md:w-1/2 gap-2">
            <input
              value={account}
              onChange={(e) => {
                setAccount(e.target.value);
                setMobile("");
                setremitterDetails([]);
                setbeneficiariesDetails([]);
              }}
              placeholder="Enter account number"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />
            <SearchOutlined
              onClick={() => account && handleSearchByAccount()}
              className={`w-10 h-10 rounded-full flex items-center justify-center
        ${account ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            />
          </div>
        </div>
        {isVerified === false && (
          <div className="mt-4 flex flex-col md:flex-row gap-3 items-center">
            <input
              value={remitterName}
              onChange={(e) => setRemitterName(e.target.value)}
              placeholder="Enter remitter name"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />

            <Button
              // type="primary"
              disabled={!remitterName}
              onClick={handleVerifyMobile}
              className={` h-10 rounded-full flex items-center justify-center
        ${mobile ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            >
              Verify Mobile
            </Button>
          </div>
        )}

        {beneModal && (
          <BeneficiaryCardxPay
            handleSearch={handleSearch}
            mobile={mobile}
            type={type}
            account={account}
            apicall={handleSearch}
            searchKeyword={searchKeyword}
            remitterDetails={remitterDetails}
            setSearchKeyWord={setSearchKeyWord}
            beneficiariesDetails={beneficiariesDetails}
            setbeneficiariesDetails={setbeneficiariesDetails}
            isVerified={isVerified}
            setIsVerified={setIsVerified}
            setMobile={setMobile}
          />
        )}
        {openOtpVerifyModal && (
          <VerifyRemitterOtp
            handleSearch={handleSearch}
            mobile={mobile}
            name={remitterName}
            isOpen={openOtpVerifyModal}
            setIsOpen={setOpenVerifyOTPModal}
          />
        )}
      </Spin>
    </>
  );
};

export default GetRemitterXPay;
